import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { RequestMetaService } from '../services/request-meta.service';

@Injectable()
export class RequestMetaInterceptor implements HttpInterceptor {

  constructor(private requestMeta: RequestMetaService) { }

  httpsHeader = new HttpHeaders({
    'x-request-id': this.requestMeta.get().requestId ?? '',
    's1-span-id': this.requestMeta.get().spanId ?? ''
  });

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.requestMeta.set(event.headers);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.requestMeta.set(error.headers);
        return throwError(() => error);
      })
    );
  }

}
